// extracted by mini-css-extract-plugin
var _1 = "assets-js-ViewInvitation-components-Guestlist-SettingsButton-module__header__poLjG";
var _2 = "assets-js-ViewInvitation-components-Guestlist-SettingsButton-module__menuText__iJWrW";
var _3 = "assets-js-ViewInvitation-components-Guestlist-SettingsButton-module__settingsMenu__mx62Z";
export { _1 as "header", _2 as "menuText", _3 as "settingsMenu" }
